import React from "react";
import { useNavigate } from "react-router-dom";
import { Share2, Layers, Wallet, ShieldCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useSEO } from "@/hooks/useSEO";

export default function ReferInfo() {
  useSEO({ title: "Refer & Earn — How It Works", path: "/refer", description: "Share financial product referral links, set your own payout, and earn transparent multi-level rewards with Credit Kendra. Start earning from your network today.", keywords: "refer and earn, referral income India, multi level rewards, share referral link earn money" });
  const nav = useNavigate();
  const { user } = useAuth();
  const steps = [
    ["Pick a campaign", "Choose any active financial product campaign.", Layers],
    ["Set your payout", "Decide how much of your allocation to keep vs. offer downstream — locked when you create the link.", ShieldCheck],
    ["Share your link", "Copy it or share on WhatsApp. Attribution is tracked securely server-side.", Share2],
    ["Earn on conversions", "Get your direct reward plus upstream differences, straight to your wallet.", Wallet],
  ];
  return (
    <div className="min-h-[70vh]">
      <section className="bg-brand-gradient text-white">
        <div className="max-w-[1280px] mx-auto px-6 py-20 text-center">
          <h1 className="font-display text-4xl lg:text-5xl font-extrabold">Refer &amp; Earn with Credit Kendra</h1>
          <p className="mt-4 text-white/80 text-lg max-w-2xl mx-auto">Turn your network into transparent, multi-level referral rewards. One pool, fair splits, zero hidden margin.</p>
          <Button onClick={() => nav(user && user !== false ? "/dashboard/refer" : "/register")}
            data-testid="refer-cta-btn" className="mt-8 bg-white text-[#0B223D] hover:bg-slate-100 font-bold rounded-full px-8 h-12">
            {user && user !== false ? "Go to Refer & Earn" : "Create free account"} <ArrowRight className="w-4 h-4 ml-1.5" />
          </Button>
        </div>
      </section>
      <div className="max-w-[1280px] mx-auto px-6 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {steps.map(([t, d, Icon], i) => (
          <div key={t} className="bg-white rounded-2xl border border-slate-200 p-6">
            <div className="w-11 h-11 rounded-xl bg-[#0B223D] text-white flex items-center justify-center mb-4"><Icon className="w-5 h-5" /></div>
            <span className="text-xs font-bold text-emerald-brand">STEP {i + 1}</span>
            <h3 className="font-display font-bold text-lg text-[#0B223D] mt-1">{t}</h3>
            <p className="text-sm text-slate-500 mt-2">{d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
